import React, { use, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ScorePieChart from './components/ScorePieChart';
import ScoreDistributionChart from './components/ScoreDistributionChart';
import AbilityPointsRadarChart from './components/AbilityPointsRadarChart';
import { ABILITY_POINTS_DICT } from '../../dto/chart';
import AbilityPieChart from './components/AbilityPointPieChart';
import { adminFetchStatisticalData } from '../../services/pstudentMissions.service';
import LoadingPage from '../components/LoadingPage';

function Component(props) {
    const { id:missionId } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    let [searchParams, setSearchParams] = useSearchParams();
    const [data, setData] = useState({});
    const fetchData = async () => {
        if(!missionId)return
        setIsLoading(true);
        let result = await adminFetchStatisticalData(props.token?.token,missionId);
        if (result.result) {
            setData(result.result);
            console.log(result.result);
        } else {
            alert('Fetch data error');
        }
        setIsLoading(false);
    }
    useEffect(() => {
        fetchData()
    },[missionId])


    if(!data.count>0) return(
        <div className='h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px]' style={{ overflowY: "auto" }}>
            <div className='p-[16px] flex flex-row items-center justify-between items-center bg-[white] rounded-[10px] gap-[8px] flex-wrap'>
                <div className='text-[#212121] text-[20px] font-[700]'>沒有任何學生的成績</div>
            </div>
            {isLoading&&<LoadingPage/>}
        </div>
    )
    return (
        <div className='h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px]' style={{ overflowY: "auto" }}>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-row items-center justify-between items-center bg-[white] rounded-[10px] gap-[8px] flex-wrap'>
                <div className='text-[#212121] text-[20px] font-[700]'>閲讀任務名稱: {data?.mission?.name}</div>
                <div className='flex flex-row items-center gap-[8px] flex-wrap'>
                    <div className='cursor-pointer text-[blue] underline text-[12px]' onClick={()=>{navigate(`/platform/results/`)}}>返回</div>
                </div>
            </div>
            {/*end of title, filter, serach box*/}

            {/*status filter*/}
            <div className='flex flex-row w-full bg-[white] rounded-[10px] p-[16px] text-[14px] flex-wrap gap-[16px] justify-start' style={{  }}>
                <div className='text-[16px] font-[700]'>所有學校</div>
                <div className='flex-1 flex flex-row gap-[24px justify-end items-center gap-[14px]'>學生總數:
                    <div className='text-[16px] font-[700]'>{data?.count}</div>
                </div>
            </div>

            <div className='flex flex-row w-full bg-[white] rounded-[10px] p-[16px] text-[14px] flex-wrap gap-[16px]' style={{  }}>
                <div className='w-[400px] min-w-[400px] flex flex-col'>
                    <div className='w-full pb-[4px]' style={{borderBottom:'1.5px solid #ccc'}}>平均成績</div>
                    <div className='w-full flex flex-row items-center justify-center'>
                        <ScorePieChart 
                            average={data?.averageScore/data?.totalScore}
                            averageText={data?.averageScore}
                            lower={data?.lowestScore/data?.totalScore}
                            lowerText={data?.lowestScore}
                            higher={data?.highestScore/data?.totalScore}
                            higherText={data?.highestScore}/>
                        <div className='w-[160px] text-[12px] h-full flex flex-col justify-center items-center gap-[8px]'>
                            <div className='w-full flex flex-row items-center gap-[8px] justify-center'>
                                平均分數
                                <div className='text-[24px] w-[100px] text-center'>{data?.averageScore}/{data?.totalScore}</div>
                            </div>
                            <div className='w-full flex flex-row items-center gap-[8px] justify-center'>
                                最低分數
                                <div className='text-[24px] w-[100px] text-center'>{data?.lowestScore}/{data?.totalScore}</div>
                            </div>
                            <div className='w-full flex flex-row items-center gap-[8px] justify-center'>
                                最高分數
                                <div className='text-[24px] w-[100px] text-center'>{data?.highestScore}/{data?.totalScore}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='flex-1 flex flex-col min-w-[400px]'>
                    <div className='w-full pb-[4px]' style={{borderBottom:'1.5px solid #ccc'}}>成績分佈</div>
                    <div className='w-full flex-1 flex flex-row items-center justify-center'>
                       <ScoreDistributionChart max={data?.totalScore||10} data={data.scoreArray||[]}/>
                    </div>
                </div>
            </div>

            <div className='flex flex-row w-full items-stretch gap-[16px] flex-wrap'>
                <div className='flex-1 max-w-[400px] min-w-[400px] flex flex-col bg-[white] rounded-[10px] p-[16px] text-[14px] justify-start items-center'>
                    <div className='w-full pb-[4px]'>成績能力點</div>
                    <AbilityPointsRadarChart data={data?.abilityPointsData}/>
                    <div className='w-full flex flex-col items-center justify-center gap-[8px]'>
                        {data?.abilityPointsLabel?.map((item,index)=>
                            <div key={index} className='w-full flex flex-col items-start gap-[8px] justify-center'>
                                <div className='text-[12px]'>{ABILITY_POINTS_DICT[item]}</div>
                            </div>
                        )}
                    </div>
                </div>
                <div className='flex-1 flex flex-col bg-[white] rounded-[10px] p-[16px] text-[14px] min-w-[400px]'>
                    <div className='w-full pb-[4px]'>成績能力點</div>
                    <div className='w-full flex flex-row items-start justify-start flex-wrap gap-[16px] rounded-[10px] p-[6px] text-[black]'>
                        {data?.abilityPointsData?.map((item,index)=>
                            <div key={index} className='p-[24px] flex flex-col items-center justify-center max-w-[200px]'>
                                <div className='text-[12px] h-[60px]'>{ABILITY_POINTS_DICT[item.label]}</div>
                                <AbilityPieChart data={item}/>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {isLoading&&<LoadingPage/>}

      

        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
